export class IdentificationType {
  id: number;
  name: string;

  static createInstance(id: number, name: string): IdentificationType {
    let idType = new IdentificationType();

    idType.id = id;
    idType.name = name;

    return idType;
  }

  constructor()
  {
    this.id = 0;
    this.name = "";
  }
}

